import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-collapsible-panel',
    templateUrl: './collapsible-panel.component.html',
    styleUrls: ['./collapsible-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class CollapsiblePanelComponent {
  @Input() collapsed = true;
  @Output() collapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggle(): void {
    this.collapsed = !this.collapsed;
    this.collapsedChange.emit(this.collapsed);
  }
}
